(function () {
    executeOnce('home-card-list', function () {
        window.homeCardGliders = [];
        init();
    });
    function init(refresh = false) {
        const cards = document.querySelector('.home-card-list') && document.querySelector('.home-card-list').querySelectorAll('.card');
        let cont1 = document.querySelector('.container-carousel-car-odd');
        let cont2 = document.querySelector('.container-carousel-car-even');


        if (cards) {

            /* Thor was here and hammered well -> Last viewed support code*/
            if(refresh) {
                const parent = cont1.parentElement;
                const ncont1 = document.createElement('div');
                const ncont2 = document.createElement('div');

                ncont1.classList.add('container-carousel-car-odd');
                ncont2.classList.add('container-carousel-car-even');

                parent.insertBefore(ncont1, cont1);
                parent.insertBefore(ncont2, cont2);

                parent.removeChild(cont1);
                parent.removeChild(cont2);

                cont1 = ncont1;
                cont2 = ncont2;
            }

            cards.forEach((el, index) => {
                if (!!(index + 1 && !((index + 1) % 2))) {
                    cont2.appendChild(el.cloneNode(true));
                } else {
                    cont1.appendChild(el.cloneNode(true));
                }
            });

            const config = {
                slidesToShow: 3,
                slidesToScroll: 1,
                draggable: true,
                itemWidth: 330,
                exactWidth: true,
                responsive: [
                    {
                        breakpoint: 1064,
                        settings: {
                            slidesToShow: 4,
                            perView: 4,
                            peek: {
                                before: 0
                            }
                        }
                    },
                    {
                        breakpoint: 775,
                        settings: {
                            slidesToShow: 3,
                            perView: 3,
                            peek: {
                                before: 0
                            }
                        }
                    },
                    {
                        breakpoint: 445,
                        settings: {
                            slidesToShow: 2,
                            perView: 2,
                            peek: {
                                before: 0
                            }
                        }
                    },
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1,
                            perView: 1
                        }
                    }
                ]
            };

            window.homeCardGliders.push(new Glider(cont1, {
                ...config,
                dots: '.container-carousel-car-odd-dots'
            }));

            window.homeCardGliders.push(new Glider(cont2, {
                ...config,
                dots: '.container-carousel-car-even-dots'
            }));


        }
    }

    publish(init, 'homeCardListInit');
}());
